import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=00833180&lang=pug&"
import script from "./FooterView.vue?vue&type=script&lang=js&"
export * from "./FooterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports